// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"424":"f5e22a36","642":"e0dea63e","708":"d574d479","745":"62677c12","787":"4048b011","951":"73437c76","972":"b0267d0e"}[chunkId] + ".chunk.js";
};